import { create } from "zustand";

import {
  InitializePaginationProperties,
  InitializeSetPaginationProperties,
  PaginationProperties,
  SetPaginationProperties
} from "../../../../../common/utils/pagination_property";

/**
 * useCadastroEpiListaPagination
 */

type State = PaginationProperties;

type Actions = SetPaginationProperties;

export const useCadastroEpiListaPagination = create<State & Actions>((set, get) => ({
  ...InitializePaginationProperties(),
  ...InitializeSetPaginationProperties(set),
}));